module.exports = __webpack_public_path__ + "static/img/QQ.880ba02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/QQ.png
// module id = Yw8I
// module chunks = 32